import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { createElement } from "@wordpress/element";
/**
 * WordPress dependencies
 */

import { getBlockType } from '@wordpress/blocks';
import { useSelect } from '@wordpress/data';
import { useEntityProp } from '@wordpress/core-data';
import { useMemo, useCallback } from '@wordpress/element';
import { createHigherOrderComponent } from '@wordpress/compose';
import { addFilter } from '@wordpress/hooks';
var EMPTY_OBJECT = {};

function useMetaAttributeSource(name, _attributes, _setAttributes) {
  var _ref = getBlockType(name) || EMPTY_OBJECT,
      _ref$attributes = _ref.attributes,
      attributeTypes = _ref$attributes === void 0 ? EMPTY_OBJECT : _ref$attributes;

  var attributes = _attributes,
      setAttributes = _setAttributes;

  if (Object.values(attributeTypes).some(function (type) {
    return type.source === 'meta';
  })) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var type = useSelect(function (select) {
      return select('core/editor').getCurrentPostType();
    }, []); // eslint-disable-next-line react-hooks/rules-of-hooks

    var _useEntityProp = useEntityProp('postType', type, 'meta'),
        _useEntityProp2 = _slicedToArray(_useEntityProp, 2),
        meta = _useEntityProp2[0],
        setMeta = _useEntityProp2[1]; // eslint-disable-next-line react-hooks/rules-of-hooks


    attributes = useMemo(function () {
      return _objectSpread({}, _attributes, Object.keys(attributeTypes).reduce(function (acc, key) {
        if (attributeTypes[key].source === 'meta') {
          acc[key] = meta[attributeTypes[key].meta];
        }

        return acc;
      }, {}));
    }, [attributeTypes, meta, _attributes]); // eslint-disable-next-line react-hooks/rules-of-hooks

    setAttributes = useCallback(function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      Object.keys(args[0]).forEach(function (key) {
        if (attributeTypes[key].source === 'meta') {
          setMeta(_defineProperty({}, attributeTypes[key].meta, args[0][key]));
        }
      });
      return _setAttributes.apply(void 0, args);
    }, [attributeTypes, setMeta, _setAttributes]);
  }

  return [attributes, setAttributes];
}

var withMetaAttributeSource = createHigherOrderComponent(function (BlockListBlock) {
  return function (_ref2) {
    var attributes = _ref2.attributes,
        setAttributes = _ref2.setAttributes,
        name = _ref2.name,
        props = _objectWithoutProperties(_ref2, ["attributes", "setAttributes", "name"]);

    var _useMetaAttributeSour = useMetaAttributeSource(name, attributes, setAttributes);

    var _useMetaAttributeSour2 = _slicedToArray(_useMetaAttributeSour, 2);

    attributes = _useMetaAttributeSour2[0];
    setAttributes = _useMetaAttributeSour2[1];
    return createElement(BlockListBlock, _extends({
      attributes: attributes,
      setAttributes: setAttributes,
      name: name
    }, props));
  };
}, 'withMetaAttributeSource');
addFilter('editor.BlockListBlock', 'core/editor/custom-sources-backwards-compatibility/with-meta-attribute-source', withMetaAttributeSource);